import { SenderGroupHeaderId } from 'owa-mail-group-headers';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import strings from 'owa-strings/owa-mail-strings';
/**
 * Get GroupHeader for row
 * @param rowKey rowKey for which we want to lookup time group header
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSortBySender(rowKey, tableView) {
    var uniqueSenders = MailRowDataPropertyGetter.getUniqueSenders(rowKey, tableView);
    var uniqueSenderHeaderText = strings.unknownSenderOrRecipient;
    var uniqueSenderHeaderId = SenderGroupHeaderId.Unknown;
    if (uniqueSenders && uniqueSenders.length > 0) {
        uniqueSenderHeaderText = uniqueSenders[0];
        uniqueSenderHeaderId = uniqueSenders[0];
    }
    return {
        headerText: function () { return uniqueSenderHeaderText; },
        headerId: uniqueSenderHeaderId,
    };
}
//# sourceMappingURL=getGroupHeaderForSortBySender.js.map